"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M21.04 3h-18v18h18zm-6 14h-2v-4h-4V7h2v4h2V7h2z"
}), 'Looks4Sharp');